import * as React from "react";
import * as _ from 'lodash';
import * as qs from 'query-string';
import { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ContainerWrapper, TableWrapper } from './styles';
import { AppActionCreators, IApplicationState, IAppState, IOpsScheduleListResponse, IOpsScheduleRefreshResponse, IOpsScheduleSaveResponse, IStaffListResponse, OpsScheduleActionCreators } from '@nkr/store/index';
import { IContact, IOpsSchedule, IOpsScheduleDay } from "@nkr/models/index";
import { DisplayType, OpsScheduleStatus } from '@nkr/enums/index';
import { Alert, Button, ButtonToolbar, FormControl, Panel, ToggleButton, ToggleButtonGroup, Modal } from 'react-bootstrap';
import EditRow from './edit-row';
import ColorSelector from './color-selector';
import Preview from './preview';
import { FormControlWrapper } from '@nkr/views/swap-management/swaps/styles';
import { IOpsScheduleWithValidation } from './ops-schedule-wih-validation';
import * as DateTimeModule from "react-datetime";
import * as moment from 'moment';

const DateTime = (DateTimeModule as any).default;

interface IOwnProps { }

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getOpsSchedule: () => Promise<IOpsScheduleListResponse>,
    refreshOpsSchedule: () => Promise<IOpsScheduleRefreshResponse>,
    getStaffList: () => Promise<IStaffListResponse>,
    saveOpsSchedule: (requestList: IOpsSchedule[]) => Promise<IOpsScheduleSaveResponse>,
    changeDisplay: (display: number) => void
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    schedule: IOpsScheduleWithValidation[],
    staffList: IContact[],
    showDeleted: number,
    autoRefresh: number,
    changeColor: {
        show: boolean,
        id: number,
        employee: string,
        backgroundColor: string,
        color: string
    },
    dirty: boolean,
    isValid: boolean,
    showRemoveStaffModal: boolean,
    staffToRemove: IContact | null
}

class OpsSchedule extends Component<TProps, IState> {
    readonly state: IState = {
        schedule: [],
        staffList: [],
        showDeleted: 1,
        autoRefresh: 1,
        changeColor: {
            show: false,
            id: 0,
            employee: '',
            backgroundColor: '',
            color: ''
        },
        dirty: false,
        isValid: true,
        showRemoveStaffModal: false,
        staffToRemove: null
    }

    refreshInterval: any;

    componentDidMount = () => {
        let parsed = qs.parse(window.location.search);
        let display = parsed.show ? parseInt(parsed.show) : this.props.app.display;

        this.props.changeDisplay(display);
        this.getData();
    }

    getData = () => {
        this.props.showLoading('One moment please...').then(() => {
            this.props.getOpsSchedule().then(response => {
                if (response.data.success) {
                    let schedule = response.data.results.schedule.map(x => {
                        let item: IOpsScheduleWithValidation = {
                            ...x,
                            validEmployee: true,
                            days: x.days.map(d => ({ ...d, validStartTime: true, validEndTime: true }))
                        };

                        return item;
                    });

                    this.setState({
                        schedule,
                        staffList: response.data.results.staffList
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    refresh = () => {
        this.props.refreshOpsSchedule().then(response => {
            if (response.data.success) {
                let schedule = response.data.results.schedule.map(x => {
                    let item: IOpsScheduleWithValidation = {
                        ...x,
                        validEmployee: true,
                        days: x.days.map(d => ({ ...d, validStartTime: true, validEndTime: true }))
                    };

                    return item;
                });

                this.setState({
                    schedule,
                    staffList: response.data.results.staffList
                });
            }
        });
    }

    validate = () => {
        let schedule = _.cloneDeep(this.state.schedule).map(x => {
            x.validEmployee = true;

            if (x.status == OpsScheduleStatus.Included) {
                x.validEmployee = x.employeeId > 0;
            }

            x.days = x.days.map(d => {
                d.validStartTime = true;
                d.validEndTime = true;

                if (x.status == OpsScheduleStatus.Included) {
                    d.validStartTime = d.startTime != '';
                    d.validEndTime = d.endTime != '';
                }

                return d;
            });

            return x;
        });

        let isValid = schedule.filter(x => {
            let validEmployee = x.validEmployee;
            let validDays = x.days.filter(d => d.validStartTime == false || d.validEndTime == false);

            return validEmployee == false || validDays.length > 0;
        }).length == 0

        return { schedule, isValid };
    }

    handleAdd = () => {
        let schedule = _.cloneDeep(this.state.schedule);
        let lastRow = _.minBy(this.state.schedule.filter(x => x.id < 0), item => item.id);
        let newId = lastRow != null ? lastRow.id - 1 : -1;

        schedule.push({
            id: newId,
            employeeId: 0,
            backgroundColor: 'white',
            color: 'black',
            status: OpsScheduleStatus.Included,
            displayOrder: schedule.length,
            validEmployee: true,
            days: [
                { id: 1, startTime: '09:30', endTime: '17:30', validStartTime: true, validEndTime: true, displayOrder: 0 },
                { id: 2, startTime: '09:30', endTime: '18:00', validStartTime: true, validEndTime: true, displayOrder: 1 },
                { id: 3, startTime: '09:30', endTime: '17:00', validStartTime: true, validEndTime: true, displayOrder: 2 },
                { id: 4, startTime: '09:30', endTime: '18:00', validStartTime: true, validEndTime: true, displayOrder: 3 },
                { id: 5, startTime: '09:30', endTime: '18:00', validStartTime: true, validEndTime: true, displayOrder: 4 },
            ]
        });

        this.setState({
            schedule
        });
    }

    handleSave = () => {
        let { schedule, isValid } = this.validate();

        this.setState({
            schedule,
            dirty: true,
            isValid
        }, () => {
            if (isValid) {
                this.props.showLoading('Saving schedule, one moment please...').then(() => {
                    this.props.saveOpsSchedule(this.state.schedule).then(response => {
                        let schedule = response.data.results.map(x => {
                            let item: IOpsScheduleWithValidation = {
                                ...x,
                                validEmployee: true,
                                days: x.days.map(d => ({ ...d, validStartTime: true, validEndTime: true }))
                            };

                            return item;
                        });

                        this.setState({
                            schedule
                        }, () => {
                            this.props.hideLoading();
                        });
                    });
                });
            }
        });
    }

    handlePickColor = (scheduleId: number) => {
        let currentEmployee = this.state.schedule.find(x => x.id == scheduleId);
        let staff = this.state.staffList.find(x => x.id == currentEmployee.employeeId);

        this.setState({
            changeColor: {
                show: true,
                id: scheduleId,
                employee: staff.firstName,
                backgroundColor: currentEmployee.backgroundColor,
                color: currentEmployee.color
            }
        })
    }

    handleMoveUp = (scheduleId: number) => {
        let schedule = _.cloneDeep(this.state.schedule);
        let currentRow = schedule.find(x => x.id == scheduleId);
        let currentDisplayOrder = currentRow.displayOrder;

        let previousRow = schedule.find(x => x.displayOrder == currentDisplayOrder - 1);

        currentRow.displayOrder = previousRow.displayOrder;
        previousRow.displayOrder = currentDisplayOrder;

        this.setState({
            schedule
        });
    }

    handleMoveDown = (scheduleId: number) => {
        let schedule = _.cloneDeep(this.state.schedule);
        let currentRow = schedule.find(x => x.id == scheduleId);
        let currentDisplayOrder = currentRow.displayOrder;

        let nextRow = schedule.find(x => x.displayOrder == currentDisplayOrder + 1);

        currentRow.displayOrder = nextRow.displayOrder;
        nextRow.displayOrder = currentDisplayOrder;

        this.setState({
            schedule
        });
    }

    handleChangeColor = (backgroundColor: string, color: string) => {
        let schedule = _.cloneDeep(this.state.schedule).map(x => {
            if (x.id == this.state.changeColor.id) {
                x.backgroundColor = backgroundColor;
                x.color = color;
            }

            return x;
        });

        this.setState({
            schedule,
            changeColor: {
                show: false,
                id: 0,
                employee: '',
                backgroundColor: '',
                color: ''
            }
        });
    }

    handleCancelColorChange = () => {
        this.setState({
            changeColor: {
                show: false,
                id: 0,
                employee: '',
                backgroundColor: '',
                color: ''
            }
        });
    }

    handleEmployeeChange = (scheduleId: number, employeeId: number) => {
        let staff = this.state.staffList.find(x => x.id == employeeId);

        let schedule = _.cloneDeep(this.state.schedule).map(x => {
            if (x.id == scheduleId) {
                if (staff != null) {
                    x.backgroundColor = staff.backgroundColor;
                    x.color = staff.color;
                }

                x.employeeId = employeeId;
            }

            return x;
        });

        this.setState({
            schedule
        });
    }

    handleStartTimeChange = (scheduleId: number, dayId: number, startTime: string) => {
        let schedule = _.cloneDeep(this.state.schedule).map(x => {
            if (x.id == scheduleId) {
                x.days = x.days.map(day => {
                    if (day.id == dayId) {
                        day.startTime = startTime;
                    }

                    return day;
                });
            }

            return x;
        });

        this.setState({
            schedule
        });
    }

    handleEndTimeChange = (scheduleId: number, dayId: number, endTime: string) => {
        let schedule = _.cloneDeep(this.state.schedule).map(x => {
            if (x.id == scheduleId) {
                x.days = x.days.map(day => {
                    if (day.id == dayId) {
                        day.endTime = endTime;
                    }

                    return day;
                });
            }

            return x;
        });

        this.setState({
            schedule
        });
    }

    handleToggleDelete = (scheduleId: number, status: OpsScheduleStatus) => {
        let schedule = _.cloneDeep(this.state.schedule).map(x => {
            if (x.id == scheduleId) {
                x.status = status;
            }

            return x;
        });

        this.setState({
            schedule
        });
    }

    handleToggleDeleted = (showDeleted: number) => {
        this.setState({
            showDeleted
        });
    }

    handleDisplayChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let display = parseInt(e.currentTarget.value);

        this.props.changeDisplay(display);

        clearInterval(this.refreshInterval);

        if (display != DisplayType.All) {
            this.refreshInterval = setInterval(() => this.refresh(), this.state.autoRefresh * 5000);
        }
    }

    handleRemoveStaff = (staffId: number) => {
        const isScheduled = this.state.schedule.some(x => x.employeeId === staffId);
        const staff = this.state.staffList.find(x => x.id === staffId);
        if (isScheduled) {
            this.setState({ showRemoveStaffModal: true, staffToRemove: staff });
        } else {
            this.removeStaffAndShifts(staffId);
        }
    }

    removeStaffAndShifts = (staffId: number) => {
        const staffList = this.state.staffList.filter(x => x.id !== staffId);
        const schedule = this.state.schedule.filter(x => x.employeeId !== staffId);
        this.setState({ staffList, schedule, showRemoveStaffModal: false, staffToRemove: null });
    }

    handleConfirmRemoveStaff = () => {
        if (this.state.staffToRemove) {
            this.removeStaffAndShifts(this.state.staffToRemove.id);
        }
    }

    handleCancelRemoveStaff = () => {
        this.setState({
            showRemoveStaffModal: false,
            staffToRemove: null
        });
    }

    calculateOfficeCoverage = () => {
        const { schedule } = this.state;
        const WORK_DAYS = 5;
        const DEFAULT_START = '06:00';
        const DEFAULT_END = '20:00';
        
        return Array.from({ length: WORK_DAYS }, (_, dayIndex) => {
            
            const daySchedules = schedule
                .filter(item => 
                    item.status === OpsScheduleStatus.Included && 
                    item.employeeId > 0
                )
                .map(item => {
                    const day = item.days.find(d => d.displayOrder === dayIndex);
                    return day?.startTime && day?.endTime ? {
                        startTime: day.startTime,
                        endTime: day.endTime
                    } : null;
                })
                .filter(Boolean);
            
            if (daySchedules.length === 0) {
                return {
                    start: DEFAULT_START,
                    end: DEFAULT_END
                };
            }
            
            const startTimes = daySchedules
                .map(day => moment(`2001-01-01 ${day.startTime}`, 'YYYY-MM-DD HH:mm', true))
                .filter(time => time.isValid());

            const endTimes = daySchedules
                .map(day => moment(`2001-01-01 ${day.endTime}`, 'YYYY-MM-DD HH:mm', true))
                .filter(time => time.isValid());

            
            const earliestStart = startTimes.length > 0 
                ? moment.min(startTimes).format('HH:mm')
                : DEFAULT_START;
                
            const latestEnd = endTimes.length > 0 
                ? moment.max(endTimes).format('HH:mm')
                : DEFAULT_END;

            return {
                start: earliestStart,
                end: latestEnd
            };
        });
    }

    render = () => {
        const staffExcludeList = [8, 6]; // AndreCarvalho and LarryMcMahon IDs
        const staffList = _.sortBy(this.state.staffList.filter(x => x.isOperations), item => item.firstName);
        const schedule = this.state.showDeleted == 2 ? this.state.schedule.filter(x => x.status == OpsScheduleStatus.Included) : this.state.schedule;
        const sortedSchedule = _.sortBy(schedule, x => x.displayOrder);
        const marginTop = this.props.app.display == DisplayType.NoMenuNoTabs ? 10 : 0;
        const coverageTimes = this.calculateOfficeCoverage();

        return (
            <>
                <ContainerWrapper className='container-fluid'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30, marginBottom: 20, marginTop }}>
                        <div style={{ flexBasis: '33%', fontSize: 28, fontWeight: 500 }}>
                            OPS IN-OFFICE SCHEDULE
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: 5 }}>Mode:</div>
                            <div style={{ marginRight: 10 }}>
                                <FormControlWrapper
                                    value={this.props.app.display}
                                    componentClass='select'
                                    style={{ fontSize: 12 }}
                                    onChange={this.handleDisplayChange}
                                >
                                    <option value='1'>Edit</option>
                                    <option value='4'>Live</option>
                                </FormControlWrapper>
                            </div>
                        </div>
                    </div>
                </ContainerWrapper>


                <ContainerWrapper className='container'>
                    {this.state.dirty && this.state.isValid == false && (
                        <Alert bsStyle='danger'>
                            Unable to save, please resolve the items in red below...
                        </Alert>
                    )}

                    {this.props.app.display == DisplayType.All ?
                        <>
                            <TableWrapper bordered>
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: 'lightblue' }}>Office Coverage</th>
                                        <th colSpan={2}>MON</th>
                                        <th colSpan={2} style={{ backgroundColor: 'lightblue' }}>TUE</th>
                                        <th colSpan={2}>WED</th>
                                        <th colSpan={2} style={{ backgroundColor: 'lightblue' }}>THU</th>
                                        <th colSpan={2}>FRI</th>
                                    </tr>
                                    <tr style={{ backgroundColor: '#133666', color: 'white' }}>
                                        <th style={{ width: 150 }}>Employee</th>
                                        <th>{coverageTimes[0]?.start || '6:00'}</th>
                                        <th>{coverageTimes[0]?.end || '20:00'}</th>
                                        <th>{coverageTimes[1]?.start || '6:00'}</th>
                                        <th>{coverageTimes[1]?.end || '20:00'}</th>
                                        <th>{coverageTimes[2]?.start || '6:00'}</th>
                                        <th>{coverageTimes[2]?.end || '20:00'}</th>
                                        <th>{coverageTimes[3]?.start || '6:00'}</th>
                                        <th>{coverageTimes[3]?.end || '20:00'}</th>
                                        <th>{coverageTimes[4]?.start || '6:00'}</th>
                                        <th>{coverageTimes[4]?.end || '20:00'}</th>
                                        <th rowSpan={2} style={{ width: 70 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedSchedule.map((item, index) =>
                                        <EditRow
                                            key={'edit-' + index}
                                            data={item}
                                            dirty={this.state.dirty}
                                            count={sortedSchedule.length}
                                            staffList={staffList}
                                            onEmployeeChange={this.handleEmployeeChange}
                                            onStartTimeChange={this.handleStartTimeChange}
                                            onEndTimeChange={this.handleEndTimeChange}
                                            onPickColor={this.handlePickColor}
                                            onToggleDelete={this.handleToggleDelete}
                                            onMoveUp={this.handleMoveUp}
                                            onMoveDown={this.handleMoveDown}
                                        />
                                    )}

                                    {schedule.length == 0 && (
                                        <tr>
                                            <td colSpan={12}>Nothing scheduled... click <strong>Add New Row</strong> to start</td>
                                        </tr>
                                    )}
                                </tbody>
                            </TableWrapper>

                            <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between' }}>
                                <Button bsStyle='primary' onClick={this.handleSave}>Save Schedule</Button>
                                <div>
                                    <ButtonToolbar>
                                        <ToggleButtonGroup type="radio" name="show-deleted" defaultValue={this.state.showDeleted}>
                                            <ToggleButton value={1} onClick={() => this.handleToggleDeleted(1)}>Show Deleted</ToggleButton>
                                            <ToggleButton value={2} onClick={() => this.handleToggleDeleted(2)}>Hide Deleted</ToggleButton>
                                        </ToggleButtonGroup>
                                    </ButtonToolbar>
                                </div>
                                <Button onClick={this.handleAdd}>Add New Row</Button>
                            </div>

                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title toggle style={{ fontSize: 14 }}>Preview...</Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    <Preview schedule={this.state.schedule} display={this.props.app.display} staffList={this.state.staffList} />
                                </Panel.Body>
                            </Panel>
                        </>
                        :
                        <Preview schedule={this.state.schedule} display={this.props.app.display} staffList={this.state.staffList} />
                    }
                </ContainerWrapper>

                <ColorSelector
                    show={this.state.changeColor.show}
                    employee={this.state.changeColor.employee}
                    backgroundColor={this.state.changeColor.backgroundColor}
                    color={this.state.changeColor.color}
                    onDone={this.handleChangeColor}
                    onCancel={this.handleCancelColorChange} />

                <Modal show={this.state.showRemoveStaffModal} onHide={this.handleCancelRemoveStaff} backdrop='static'>
                    <Modal.Header closeButton>Remove Staff Member</Modal.Header>
                    <Modal.Body>
                        This person is still scheduled for shifts. Removing them will also remove all their scheduled shifts. Are you sure you want to continue?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleCancelRemoveStaff}>Cancel</Button>
                        <Button bsStyle='danger' onClick={this.handleConfirmRemoveStaff}>Confirm</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getOpsSchedule: () => {
            return dispatch(OpsScheduleActionCreators.getOpsSchedule());
        },
        refreshOpsSchedule: () => {
            return dispatch(OpsScheduleActionCreators.refreshOpsSchedule());
        },
        getStaffList: () => {
            return dispatch(OpsScheduleActionCreators.getStaffList());
        },
        saveOpsSchedule: (requestList) => {
            return dispatch(OpsScheduleActionCreators.saveOpsSchedule(requestList));
        },
        changeDisplay: (display: number) => {
            dispatch(AppActionCreators.changeDisplay(display));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(OpsSchedule);